var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.HOME-Copy-2",
    transform: "translate(-290.000000, -899.000000)",
    fill: "#9E9E9E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(229.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(45.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_gift_1253598_000000",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76658811,22 L18.9855022,22 L18.9855022,14.7959322 L19.8814655,14.7959322 L19.8814655,10.56 L4.36422414,10.56 L4.36422414,14.7959322 L5.26018744,14.7959322 L5.26018744,22 L9.76658811,22 Z M13.387339,20.8509178 L10.8594004,20.8509178 L10.8583753,11.8570195 L13.3863139,11.8570195 L13.387339,20.8509178 Z M17.8937922,20.8509178 L14.4779993,20.8509178 L14.4779993,14.795877 L17.8937922,14.795877 L17.8937922,20.8509178 Z M18.7897555,13.6479548 L14.4780256,13.6479548 L14.4780256,11.7091099 L18.7897555,11.7091099 L18.7897555,13.6479548 Z M5.4559342,11.7091099 L9.76766407,11.7091099 L9.76766407,13.6479548 L5.4559342,13.6479548 L5.4559342,11.7091099 Z M9.76661435,14.7960151 L9.76661435,20.8510559 L6.35187125,20.8510559 L6.35187125,14.7960151 L9.76661435,14.7960151 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95043103,9.68 L11.2607759,9.68 L11.2607759,6.09276197 L6.95043103,5.28 L6.95043103,9.68 Z M7.9986847,6.7111201 L10.2114629,7.12837283 L10.2114629,8.4624227 L7.9986847,8.4624227 L7.9986847,6.7111201 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4331897,5.28 L12.1228448,6.0925458 L12.1228448,9.68 L16.4331897,9.68 L16.4331897,5.28 Z M15.384936,8.46283431 L13.1731414,8.46283431 L13.1731414,7.12913926 L15.384936,6.7119975 L15.384936,8.46283431 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.3125256 1.76 19.0193966 4.4 21.6056034 4.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.34751979 11.44 0.0538793103 14.08 2.64008621 14.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "22.4676724 19.3952948 23.2951658 20.24 23.7429222 19.781775 24.1918103 19.3247052 23.364317 18.48 24.1918103 17.6364501 23.7429222 17.178225 23.2951658 16.72 22.4676724 17.5647052 21.6413108 16.72 20.7435345 17.6364501 21.5710278 18.48 20.7435345 19.3247052 21.1924226 19.781775 21.6413108 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.10829016 5.28 4.10829016 4.13874259 5.2262931 4.13874259 5.2262931 2.90125741 4.10829016 2.90125741 4.10829016 1.76 2.89602019 1.76 2.89602019 2.90125741 1.77801724 2.90125741 1.77801724 4.13874259 2.89602019 4.13874259 2.89602019 5.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9849138,0.88 C12.9849138,0.395401292 12.5985385,0 12.1228448,0 C11.6481204,0 11.2607759,0.3944119 11.2607759,0.88 C11.2607759,1.36459871 11.6471512,1.76 12.1228448,1.76 C12.5985385,1.75900909 12.9849138,1.36459871 12.9849138,0.88 L12.9849138,0.88 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4676724,11.44 C22.9423969,11.44 23.3297414,11.0455881 23.3297414,10.56 C23.3297414,10.0754013 22.9433661,9.68 22.4676724,9.68 C21.992948,9.68 21.6056034,10.0744119 21.6056034,10.56 C21.6056034,11.0455881 21.9919787,11.44 22.4676724,11.44 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64008621,19.36 C2.16536177,19.36 1.77801724,19.7544119 1.77801724,20.24 C1.77801724,20.7245987 2.16439254,21.12 2.64008621,21.12 C3.11481065,21.12 3.50215517,20.7255881 3.50215517,20.24 C3.50215517,19.7544119 3.11577988,19.36 2.64008621,19.36 L2.64008621,19.36 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDream);
export default __webpack_public_path__ + "static/media/ico_dream.2672f0421f44fc5692829e0f9cd9d107.svg";
export { ForwardRef as ReactComponent };